import { render, staticRenderFns } from "./Slider.vue?vue&type=template&id=73b1d81a&scoped=true&"
import script from "./Slider.vue?vue&type=script&setup=true&lang=js&"
export * from "./Slider.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Slider.vue?vue&type=style&index=0&id=73b1d81a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b1d81a",
  null
  
)

export default component.exports